import { Component } from "react";
import { ToastContainer } from "react-toastify";
import Loader from "../../../utils/Loader";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../utils/withRouter";
import { getManualForms_action } from "../../../actions/exhibitor_module_actions/manual_Forms_actions/manual_forms_action";
import { connect } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import {
  countryActionId,
  toastError,
  toastSuccess,
  exhibitorBadgeDaysActionId,
  DOC_BASE_URL,
} from "../../../utils/constants";
import $ from "jquery";
import moment from "moment";
class ManualForms extends Component {
  // Initialize Constructor
  constructor(props) {
    super(props);
    //States
    this.state = {
      isLoading: false,
      List: [],
      OverDueFormCount: 0,
      OverDueFormCountList: [],
      MFDeadlineDays: 0,
      AllManualFormList: [],
      showDocModal: false,
      selectedDoc: null,
    };
  }

  componentDidMount() {
    var Deadline = this.props.location.state != null &&
      this.props.location.state != "" &&
      this.props.location.state.Deadline != ""
      ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
      : ""
    this.setState({
      DeadlineDate:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
          : "",
    });
    this.getManualFormsList().then(() => {
      if (this.props.location.state != null && (this.props.location.state.dash)) {
        console.log(this.state.AllManualFormList, this.props.location.isClicked, this.props.location.isClicked == 1)
        if (this.props.location.state.isClicked == 1) {
          this.setState({
            List: this.state.AllManualFormList.filter(
              (item) => item.FormType == "Mandatory"
            ),
          })
        } else if (this.props.location.state.isClicked == 2) {
          this.setState({
            List: this.state.AllManualFormList.filter(
              (item) => item.Status == "Approved"
            ),
          })
        } else if (this.props.location.state.isClicked == 3) {
          this.setState({
            List: this.state.AllManualFormList.filter(
              (item) => item.Status == "Applied"
            ),
          })
        } else if (this.props.location.state.isClicked == 4) {
          this.setState({
            List: this.state.AllManualFormList.filter(
              (item) => (item.Deadline >= new Date()) && item.Deadline <= new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000)),
          })
        } else if (this.props.location.state.isClicked == 5) {
          this.setState({
            List: this.state.AllManualFormList.filter(
              (item) => (new Date(item.Deadline) < new Date())),
          })
        } else if (this.props.location.state.isClicked == 6) {
          this.setState({
            List: this.state.AllManualFormList.filter(
              (item) => item.Status == "Not Filled" && item.FormType == 'Mandatory'
            ),
          })
        }
      }
    })
    this.loadscript();
  }

  loadscript() {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }

  handleOpenForm(
    ID,
    deadline,
    StatusID,
    name,
    ServiceID,
    isVendorSelectionAllowed,
    IsNonEmpanelCard,
    item
  ) {
    const deadlineState = sessionStorage.getItem("isIndirectAccess") == "true" ? null : deadline;

    const obj = {
      CompanyName: item.VendorCompanyName,
      PersonName: item.VendorName,
      EmailID: item.VendorEmail,
      MobileNo: item.VendorMobileNo,
      VendorMDName: item.VendorMDName != ' ' ? item.VendorMDName : null,
      VendorMDMobileNo: item.VendorMDMobileNo,
      VendorMDEmaiId: item.VendorMDEmaiId,
    }

    if (isVendorSelectionAllowed && (StatusID == 0)) {
      this.props.navigate("/manualFormsVendorList", {
        state: {
          Deadline: deadline,
          StatusID: StatusID != 2 ? StatusID : (sessionStorage.getItem("isIndirectAccess") == "true" ? null : StatusID),
          ManualFormsID: ID,
          ManualFormsName: name,
          ServiceID: ServiceID,
          ActualDeadline: deadline,
          isVendorSelectionAllowed,
          VendorDetails: obj,
          IsNonEmpanelCard,
          DeadlineDate: "",
          currentDate: moment().format("DD-MM-YYYY"),
          VendorDetailShow: item.isITMEBilling == 0 ? obj : null,
          isITMEBilling: item.isITMEBilling
        },
      });
    } else {
      const routeMap = {
        1: "/fascia-form",
        2: "/exhibitorbadge",
        3: "/exhibitorDetails",
        4: "/visaApplication",
        5: "/edirectoryList",
        6: "/keywordsInformation",
        7: "/stallDesign",
        8: "/aditionalfurniture",
        9: "/stallpossesion",
        10: "/powerConnection",
        11: "/freightForward",
        12: "/water",
        13: "/airConnectionApplication",
        14: "/carPassesApplication",
        15: "/liquareLicense",
        31: "/prAgency",
        16: "/leadRetrievalConnectionApplication",
        17: "/meetingRoomRequestForm",
        18: "/delegateMeeting",
        19: "/visitorMeetingApplication",
        20: "/internetConnection",
        21: "/housekeepingConnection",
        22: "/securityApplication",
        23: "/cateringServices",
        24: "/hostHostessRequirements",
        25: "/brandingApportunityAndAdvertisement",
        26: "/rentalAudioAndVedioEquipment",
        27: "/exhibitorContractorBadgeApplication",
        28: "/plantAndBeautification",
        29: "/sponsorship",
        30: "/hotelEnquiry",
        32: "/photographyAndVideography",
      };
      const path = routeMap[ID];
      this.props.navigate(path, {
        state: {
          Deadline: deadlineState,
          VendorDetails: obj,
          is_View:
            sessionStorage.getItem("isIndirectAccess") == "true"
              ? false
              : sessionStorage.getItem("RoleIDSS") != 1,
          Is_View:
            sessionStorage.getItem("isIndirectAccess") == "true"
              ? false
              : sessionStorage.getItem("RoleIDSS") != 1,
          ActualDeadline: deadline,
          StatusID: StatusID != 2 ? StatusID : (sessionStorage.getItem("isIndirectAccess") == "true" ? null : StatusID),
          ManualFormsID: ID,
          ServiceID: ServiceID,
          VendorDetailShow: item.isITMEBilling == 0 ? obj : null,
          isITMEBilling: item.isITMEBilling
        },
      });
    }
  }

  getManualFormsList() {
    this.setState({ isLoading: true });
    return new Promise((resolve, reject) => {
      this.props
        .getManualForms_action()
        .then((data) => {
          if (data.error != 1) {
            console.log("getManualForms_action", data);
            if (data.data.length > 0) {
              const today = new Date();
              const MFDeadlineDays = data.data[0]["MFDeadlineDays"] || 0;

              // check deadlines within 3 days
              const dueSoon = data.data.filter((item) => {
                const deadline = new Date(item.Deadline);
                const diffTime = deadline - today;
                const diffDays = diffTime / (1000 * 60 * 60 * 24); // convert ms → days
                return diffDays >= -1 && diffDays < MFDeadlineDays - 1;
              });

              // console.log("Forms due within 3 days:", dueSoon);
              this.setState({
                List: data.data,
                AllManualFormList: data.data,
                isLoading: false,
                OverDueFormCount: dueSoon.length,
                OverDueFormCountList: dueSoon,
                MFDeadlineDays: MFDeadlineDays,
              }, () => {
                resolve()
              });
            } else {

              resolve()
            }
            // setTimeout(() => {
            // }, 100);
            this.setState({ isLoading: false });
          } else {
            resolve()
            this.setState({ isLoading: false });
            toastError(data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }).catch(err => {
      console.log(err);
    })

    setTimeout(() => {
      console.log(this.state.List);
    }, 200);
  }

  getRandomLightColor() {
    const hue = Math.floor(Math.random() * 360); // any hue
    const saturation = 45 + Math.random() * 15; // 45–60% (soft)
    const lightness = 80 + Math.random() * 8; // 80–88% (lighter than before)

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  }

  render() {
    const {
      isLoading,
      List,
      OverDueFormCount,
      OverDueFormCountList,
      MFDeadlineDays,
      AllManualFormList,
      DeadlineDate,
      currentDate,
    } = this.state;
    const isDeadlinePassed =
      DeadlineDate &&
      moment(DeadlineDate, "DD-MM-YYYY").isValid() &&
      moment(currentDate, "DD-MM-YYYY").isAfter(moment(DeadlineDate, "DD-MM-YYYY"));
    // console.log("List------------->", List)
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        <ExhibitorHeader />
        <ExhibitorDrawer />
        {/*app-content open*/}
        <div className="page">
          <div className="page-main">
            <div className="main-content with-dr-container">
              {/* <div className="container-fluid">
                                <div className="row">
                                    <div className="tab-scroll-fixed">
                                <p>Exhibitor Dashboard</p>
                            </div>
                                    <ExhibitorTopMenu />
                                </div>
                            </div> */}
              <div className=" width-dr-nav">
                <div className="row mt-5">
                  <ExhibitorTopMenu />
                </div>
              </div>
              <div className="row">
                <div className="col-xl-12">
                  <div className="card rounded-0 pt-1 shadow-none">
                    {/* <div className="card-header p-2">
                                            <h3 className="card-title"> Manual Forms</h3>
                                        </div> */}
                    <div className="card-body p-2">
                      <div className="row">
                        <div className="container pb-5" style={{ position: "relative" }}>
                          <div className="form-status">
                            <span
                              className="badge-status corporate-badge mandatory"
                              onClick={() =>
                                this.setState({
                                  List: AllManualFormList.filter(
                                    (item) => item.FormType == "Mandatory"
                                  ),
                                })
                              }
                            >
                              Mandatory:{" "}
                              {
                                AllManualFormList.filter((item) => item.FormType == "Mandatory")
                                  .length
                              }
                            </span>
                            <span
                              className="badge-status corporate-badge optional"
                              onClick={() =>
                                this.setState({
                                  List: AllManualFormList.filter(
                                    (item) => item.FormType == "Optional"
                                  ),
                                })
                              }
                            >
                              Optional:{" "}
                              {
                                AllManualFormList.filter((item) => item.FormType == "Optional")
                                  .length
                              }
                            </span>
                            <span
                              className="badge-status corporate-badge all"
                              onClick={() => this.setState({ List: AllManualFormList })}
                            >
                              All: {AllManualFormList.length}
                            </span>
                          </div>
                          {OverDueFormCount != 0 && (
                            <p
                              className="status-badge-filled blink"
                              style={{ cursor: "pointer" }}
                              onClick={() => this.setState({ List: OverDueFormCountList })}
                            >
                              <span className="">Reminder: </span> {OverDueFormCount} forms have a
                              deadline within the next {MFDeadlineDays} days.
                            </p>
                          )}
                          <div className="row mt-5">
                            {List.length > 0 ? (
                              List.map((item, i) => {
                                const randomColor = this.getRandomLightColor();
                                const isDeadlinePassed =
                                  item.Deadline &&
                                  moment.utc(item.Deadline).isValid() &&
                                  moment
                                    .utc()
                                    .startOf("day")
                                    .isAfter(moment.utc(item.Deadline).startOf("day"));
                                if (item.ManualFormID == 11) console.log("Form 11 data:", item);
                                return (
                                  <div className="col-md-4 mt-2" key={i}>
                                    <div className="custom-card h-100 d-flex flex-column">

                                      <div className="d-flex align-items-center justify-content-between">
                                        <span className="badge cir-color rounded-circle p-2">
                                          {String(i + 1).padStart(2, "0")}
                                        </span>
                                        {item.DisplayName != 'SPONSORSHIP OPPORTUNITY' && item.DisplayName != 'HOTEL RESERVATION' ?
                                          <span
                                            className={
                                              item.Status == "Approved"
                                                ? "status-badge-notfilled"
                                                : item.Status == "Disapproved"
                                                  ? "status-badge-notfilled"
                                                  : item.Status == "Not Filled"
                                                    ? "status-badge-notfilled"
                                                    : item.Status == "Applied"
                                                      ? "status-badge-notfilled"
                                                      : ""
                                            }
                                          >
                                            {item.Status.toUpperCase()}
                                          </span> :
                                          ''}
                                      </div>

                                      <p className="text-muted fw-600 mb-2 p-1 rounded-1 text-dark">
                                        {item.DisplayName}
                                      </p>

                                      {item.DisplayName != 'SPONSORSHIP OPPORTUNITY' && item.DisplayName != 'HOTEL RESERVATION' ?
                                        <div
                                          className="d-flex align-items-center text-muted mb-1"
                                          style={{ justifyContent: "space-between" }}
                                        >
                                          <span>
                                            <i className="bi bi-calendar-event me-2 grid-icon" />
                                            <span className="dedline-text">
                                              Deadline:{" "}
                                              <strong className="fw-600">
                                                {moment(item.Deadline).format("D MMMM, YYYY")}
                                              </strong>
                                            </span>
                                          </span>
                                          <span
                                            className={
                                              item.FormType === "Optional"
                                                ? "badge bg-aqua fw-normal ms-2"
                                                : "badge bg-aqua fw-normal ms-2"
                                            }
                                          >
                                            {item.FormType}
                                          </span>
                                        </div> :
                                        ''}

                                      <span className="fw-bold text-muted text-left" style={{ fontSize: 12 }}>
                                        {item.VendorCompanyName} {item.VendorName ? "|" : ""}{" "}
                                        {item.VendorName} {item.VendorEmail ? "|" : ""}{" "}
                                        {item.VendorEmail} {item.VendorMobileNo ? "|" : ""}{" "}
                                        {item.VendorMobileNo}
                                      </span>
                                      {isDeadlinePassed && (
                                        <div className="text-danger text-left">
                                          The deadline has been passed
                                        </div>
                                      )}
                                      <div className="d-flex align-items-center gap-2 mt-auto">
                                        <button className="btn btn-aqua-border py-1-border w-100 view-btn m-0 mt-2"
                                          onClick={() =>
                                            this.handleOpenForm(
                                              item.ManualFormID,
                                              item.Deadline,
                                              item.StatusID,
                                              item.Name,
                                              item.ServiceID,
                                              item.isVendorSelectionAllowed,
                                              item.IsNonEmpanelCard,
                                              item
                                            )
                                          }
                                          style={{
                                            cursor:
                                              item.Status == "Not Filled" && isDeadlinePassed
                                                ? "default"
                                                : "pointer",
                                          }}
                                          disabled={
                                            item.Status == "Not Filled" ? isDeadlinePassed : false
                                          }
                                        >
                                          {item.Status == "Approved"
                                            ? "View the Form"
                                            : item.Status == "Not Filled"
                                              ? "Fill the Form"
                                              : "Update the Form"}
                                        </button>
                                        {!item.isITMEBilling && item.InvoiceDocument && (
                                          <button
                                            className="btn btn-aqua mt-2"
                                            onClick={() =>
                                              this.setState({
                                                showDocModal: true,
                                                selectedDoc: item.InvoiceDocument ? `${DOC_BASE_URL}${item.InvoiceDocument}` : null,
                                              })
                                            }
                                            title="View Document"
                                          >
                                            <i className="bi bi-file-earmark-image" />
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <div>Record not found</div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.showDocModal && (
          <div
            className="modal fade show"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
            onClick={() => this.setState({ showDocModal: false, selectedDoc: null })}
          >
            <div className="modal-dialog modal-xl" onClick={(e) => e.stopPropagation()}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Invoice Document</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => this.setState({ showDocModal: false, selectedDoc: null })}
                  />
                </div>
                <div className="modal-body text-center">
                  {this.state.selectedDoc ? (
                    <img
                      src={this.state.selectedDoc}
                      alt="Invoice"
                      style={{ maxWidth: "100%", height: "auto" }}
                      onError={(e) =>
                      (e.target.src =
                        'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="200"%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="%23999"%3EImage not found%3C/text%3E%3C/svg%3E')
                      }
                    />
                  ) : (
                    <div className="text-muted py-5">
                      <i className="bi bi-file-earmark-x" style={{ fontSize: "3rem" }} />
                      <p className="mt-3">No document available</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default withRouter(connect(null, { getManualForms_action })(ManualForms));
